import { EditPencilIcon } from "@/components/icons/edit-pencil-icon";
import { TextButton } from "@/components/ui/buttons";
import { cn } from "@/utils/cn";

interface EditMealButtonProps {
  className?: string;
  ariaLabel?: string;
  /** Called when the user taps the edit button (e.g. to open the edit your food modal) */
  onEdit?: () => void;
}

/**
 * Edit meal button for the meal detail header.
 * Opens the edit your food flow when used for Your Food meals.
 */
export const EditMealButton = ({
  className,
  ariaLabel = "Edit meal",
  onEdit,
}: EditMealButtonProps) => {
  const handleEdit = () => {
    onEdit?.();
  };

  return (
    <TextButton
      type="button"
      className={cn("flex h-fit items-center justify-center", className)}
      onClick={handleEdit}
      aria-label={ariaLabel}
    >
      <EditPencilIcon className="h-6 w-6" />
    </TextButton>
  );
};
